export default __webpack_public_path__ + "media/zurb/img/events/wired/rebuilding/rebuilding-photos-776ea6a72ffb9bdf4c0125c0a8579cd5.png";